
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class SpinnerService {

    spinnerVisible = false;
    deletedItemId = -1;

    showSpinner() {
        this.spinnerVisible = true;
    }

    hideSpinner() {
        this.spinnerVisible = false;
    }

    showDeleteButtonSpinner(deletedItemId: number) {
        this.deletedItemId = deletedItemId;
    }

    hideDeleteButtonSpinner() {
        this.deletedItemId = -1;
    }
}